<template>
  <div class="grid-container full">
    <div class="grid-x wantToKnowMoreBox">
      <div class=" small-12 cell text-center">
        <div class="grid-x">
          <div class="small-12 cell">
            <h2>Want to know more?</h2>
          </div>
        </div>


        <div v-if="WantToKnowMoreBody === ''">
          &nbsp;
        </div>
        <div v-else>
          <div class="grid-x">
            <div class="small-12 cell text-right">
              <p>{{ WantToKnowMoreBody }}</p>
            </div>
          </div>
        </div>
        <div class="grid-x">
          <div class="small-12 cell">
          <rare-standard-button
            tabindex="70"
            class="contactButton show-for-small-only"
            :active="'true'"
            :buttonText="'Get in touch'"
            :height="'40px'"
            :fontColor="'#ffffff'"
            :fontSize="'12px'"
            @clicked="openContactForm"
          />
            <rare-standard-button
              tabindex="70"
              class="contactButton show-for-medium"
              :buttonText="'Get in touch'"
              :height="'64px'"
              :width="'282px'"
              :fontColor="'#ffffff'"
              :fontSize="'16px'"
              @clicked="openContactForm"
            />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RareStandardButton from '@/components/atoms/RareWebButton';
import RareEmailIcon from 'rare-patternlab/icons/communication/RareEmailIconWhite';
import RarePhoneIcon from 'rare-patternlab/icons/communication/RarePhoneIconWhite';

export default {
  name: 'RareWantToKnowMore',
  components: {
    'rare-standard-button': RareStandardButton,
    'rare-email-icon': RareEmailIcon,
    'rare-phone-icon': RarePhoneIcon,
  },
  data() {
    return {
      w: window.width,
    };
  },
  props: {
    WantToKnowMoreTitle: {
      type: String,
      required: false,
      default: 'Want to know more?',
    },
    WantToKnowMoreBody: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    openContactForm() {
      this.$root.$emit('updateContactForm', true);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  h2
  {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
    text-transform: uppercase;
  }

  p, a {
    color: #ffffff;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    height: 40px;
    letter-spacing: 0.2px;
  }

  .contactLink {
    display: inline-block;
    text-decoration: none;
  }

  .contactIcon {
    display: inline-block;

  }

  .contactDetail {
    display: inline-block;
  }

  @media only screen and (max-width: 640px)  {
    .wantToKnowMoreBox {
      height: 310px;
      background-image: url("../../assets/img/backgrounds/want-to-know-more.jpg");
      background-position: center;
    }

    .email {
      margin-right: 0;
    }

    .phone {
      margin-left: 0;
    }

    .press-release {
      margin-top: 0;
    }

    h2 {
       font-size: 24px;
       line-height: 1.33;
       letter-spacing: 3px;
       margin: 80px 0 16px 0;
     }
    .contactButton {
      margin: 30px auto 0 auto;
    }
  }

  @media only screen and (min-width: 641px)  {
    .wantToKnowMoreBox {
      height: 365px;
      background-image: url("../../assets/img/backgrounds/want-to-know-more.jpg");
    }

    .email {
      margin-right: 35px;
    }

    .phone {
      margin-left: 35px;
    }

    .press-release {
      margin-top: 20px;
    }

    h2 {
      font-size: 48px;
      line-height: 0.83;
      letter-spacing: 8px;
      margin: 90px 0 24px 0;
    }

    .contactButton {
      margin: 35px auto 0 auto;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/commonSections/RareWantToKnowMore.vue